<!-- eslint-disable indent -->
<template>
  <div class="main">
    <head-main></head-main>

    <div style="min-height: 100vh;">
      <router-view></router-view>
    </div>

    <footers></footers>
  </div>
</template>

<script>
  import headMain from "@/views/headers/index"
  import footers from "@/views/footer/index"
  export default {
    components: {
      headMain,
      footers,
    },
    name: 'index',
    data() {
      return {

      }
    },
    mounted() {



    },
    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index.vue